import './styles.scss';
import { useTranslation } from 'react-i18next';
import { Handle, Position } from '@xyflow/react';
import { IconPlus } from '@tabler/icons-react';
import { Text } from '@fragments';

export default function AddBlockNode() {
    const { t } = useTranslation('formsModals');

    return (
        <div className="add-block-node">
            <Handle
                type="target"
                position={Position.Top}
                style={{ opacity: 0, pointerEvents: 'none' }}
            />
            <IconPlus size={16} />
            <Text.span contrast={5}>{t('builder.canvas.addBlock')}</Text.span>
        </div>
    );
}
